/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useState, useEffect, useCallback, useImperativeHandle, useRef } from 'react';
import { CarouselContext } from 'pure-react-carousel';
export var useCarousel = function (ref, _a) {
    var _b, _c, _d, _e;
    var _f = _a === void 0 ? {} : _a, onSlideChange = _f.onSlideChange, _g = _f.initialSlide, initialSlide = _g === void 0 ? 0 : _g;
    var carouselContext = useContext(CarouselContext);
    var _h = useState((_c = (_b = carouselContext === null || carouselContext === void 0 ? void 0 : carouselContext.state) === null || _b === void 0 ? void 0 : _b.currentSlide) !== null && _c !== void 0 ? _c : initialSlide), currentSlide = _h[0], setCurrentSlide = _h[1];
    var _j = useState((_e = (_d = carouselContext === null || carouselContext === void 0 ? void 0 : carouselContext.state) === null || _d === void 0 ? void 0 : _d.isPlaying) !== null && _e !== void 0 ? _e : false), isPlaying = _j[0], setIsPlaying = _j[1];
    // Store onSlideChange in a ref to avoid triggering re-renders
    var onSlideChangeRef = useRef(onSlideChange);
    useEffect(function () {
        onSlideChangeRef.current = onSlideChange;
    }, [onSlideChange]);
    // Memoized state update function to avoid unnecessary re-renders
    var onChange = useCallback(function () {
        if (!carouselContext) {
            return;
        }
        var newSlide = carouselContext.state.currentSlide;
        var newIsPlaying = carouselContext.state.isPlaying;
        setCurrentSlide(function (prev) { return (prev !== newSlide ? newSlide : prev); });
        setIsPlaying(function (prev) { return (prev !== newIsPlaying ? newIsPlaying : prev); });
        if (onSlideChangeRef.current) {
            onSlideChangeRef.current(newSlide);
        }
    }, [carouselContext]);
    // Subscribe to carousel state changes efficiently
    useEffect(function () {
        if (!carouselContext) {
            return;
        }
        carouselContext.subscribe(onChange);
        return function () { return carouselContext.unsubscribe(onChange); };
    }, [carouselContext, onChange]);
    // Memoized functions to avoid unnecessary re-renders
    var goToSlide = useCallback(function (index) {
        carouselContext === null || carouselContext === void 0 ? void 0 : carouselContext.setStoreState({ currentSlide: index });
    }, [carouselContext]);
    var next = useCallback(function () {
        if (!carouselContext) {
            return;
        }
        var _a = carouselContext.state, currentSlide = _a.currentSlide, totalSlides = _a.totalSlides;
        goToSlide((currentSlide + 1) % totalSlides);
    }, [carouselContext, goToSlide]);
    var prev = useCallback(function () {
        if (!carouselContext) {
            return;
        }
        var _a = carouselContext.state, currentSlide = _a.currentSlide, totalSlides = _a.totalSlides;
        goToSlide((currentSlide - 1 + totalSlides) % totalSlides);
    }, [carouselContext, goToSlide]);
    var stopAutoplay = useCallback(function () {
        carouselContext === null || carouselContext === void 0 ? void 0 : carouselContext.setStoreState({ isPlaying: false });
    }, [carouselContext]);
    var resumeAutoplay = useCallback(function () {
        carouselContext === null || carouselContext === void 0 ? void 0 : carouselContext.setStoreState({ isPlaying: true });
    }, [carouselContext]);
    useImperativeHandle(ref, function () { return ({
        goToSlide: goToSlide,
        next: next,
        prev: prev,
        getCurrentSlide: function () { return currentSlide; },
        stopAutoplay: stopAutoplay,
        resumeAutoplay: resumeAutoplay,
        isAutoPlaying: isPlaying,
    }); }, [goToSlide, next, prev, currentSlide, stopAutoplay, resumeAutoplay, isPlaying]);
    return {
        currentSlide: currentSlide,
        goToSlide: goToSlide,
        next: next,
        prev: prev,
        stopAutoplay: stopAutoplay,
        resumeAutoplay: resumeAutoplay,
        isAutoPlaying: isPlaying,
    };
};
